import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { useLocalizedHref } from "@/lib/i18n-routing";

/**
 * Drop-in replacement for react-router-dom's <Link> that automatically
 * prefixes internal `to` paths with the current language (/ar, /hi).
 * External URLs (http://, https://, mailto:, tel:) are passed through.
 */
const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...rest }, ref) => {
    const localize = useLocalizedHref();
    let next: LinkProps["to"] = to;
    if (typeof to === "string") {
      const isExternal = /^([a-z][a-z0-9+.-]*:|\/\/)/i.test(to);
      next = isExternal ? to : localize(to);
    }
    return <Link ref={ref} to={next} {...rest} />;
  },
);
LocaleLink.displayName = "LocaleLink";

export default LocaleLink;
